"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const menu_1 = __importDefault(require("../data/menu"));
const location_1 = require("../select/location");
const dict_1 = require("./../select/dict");
const overdue_1 = require("../select/overdue");
const select_1 = require("../select");
const user_1 = __importDefault(require("@/data/user"));
const complex_1 = require("../select/complex");
const cascader_1 = require("../select/cascader");
const litigation_1 = require("../select/litigation");
const depend = (0, vue_1.reactive)({
    load: 'un',
    loadMain() {
        return new Promise((resolve, reject) => {
            this.load = 'ing';
            user_1.default.refreshInfo().finally(() => {
                menu_1.default.$loadData().then(() => {
                    this.load = 'end';
                    resolve({ status: 'success' });
                }).catch(err => {
                    this.load = 'un';
                    // eslint-disable-next-line no-console
                    console.error(err);
                    reject(err);
                });
            });
        });
    },
    loadExtra() {
        return Promise.allSettled([(0, dict_1.loadDict)(), (0, cascader_1.loadCascader)(), location_1.location.$loadData(), litigation_1.auctionStatus.$loadData(), (0, overdue_1.loadOverdueDict)(), (0, select_1.loadAllDict)(), complex_1.parkingPointSelect.$loadData(true), complex_1.serviceProviderSelect.$loadData(true)]);
    },
    loadData() {
        return new Promise((resolve, reject) => {
            this.loadMain().then(() => {
                this.loadExtra().finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    },
    reset() {
        menu_1.default.reset();
        this.load = 'un';
    }
});
exports.default = depend;
